/**
 * Corporate branding shown to users and hotels. Hotel brands (Best Western, SureStay,
 * WorldHotels Collection, ...) are not company branding; their logos live in img/logos.ts.
 *
 * Keep in sync with packages/core/src/helpers/company-branding.ts, which holds the
 * backend copy used by the automated report emails.
 *
 * Wording confirmed for the WorldHotels rebrand (RM-2358).
 */

/** Name shown after the copyright symbol in page footers. */
export const COPYRIGHT_HOLDER = 'WorldHotels';

/** Signature used on report emails when the Revenue Manager's name is unknown. */
export const DEFAULT_REVENUE_MANAGER_NAME = 'WorldHotels Revenue Manager';

/**
 * Sender address for report emails; must be a verified SES identity.
 * Unchanged until IT decides on the WorldHotels sending domain (RM-2358).
 */
export const REPORT_FROM_EMAIL = 'reports@mail.rmws.bwhhotelgroup.com';
